import script from "./abstarct-terminal-view.vue?vue&type=script&lang=ts&setup=true"
export * from "./abstarct-terminal-view.vue?vue&type=script&lang=ts&setup=true"

import "./abstarct-terminal-view.vue?vue&type=style&index=0&id=980df5a4&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-980df5a4"]])

export default __exports__